import { fetcher } from '@commenda/utils';

export async function deleteAffiliateFirm(affiliateFirmId: string) {
  const response = await fetcher(`affiliate-firms/${affiliateFirmId}`, {
    method: 'DELETE',
  });

  return response;
}
